var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"id":"sidebarnav"}},_vm._l((_vm.items),function(nav,key){return _c(_vm.resolveNavComp(nav),{key:key,tag:"component",attrs:{"item":nav}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }